'use client';

import * as React from 'react';

import { cn } from '../../lib/cn';
import { type LinkLike, NativeLink } from '../../lib/link';

export interface NavPillItem {
	/** Testo della pillola. */
	label: React.ReactNode;
	/** URL di destinazione. */
	href: string;
	/** Se true, evidenzia la pillola come sezione corrente. */
	active?: boolean;
}

export interface NavPillsProps extends React.HTMLAttributes<HTMLElement> {
	/** Voci di navigazione da mostrare come pillole. */
	items: NavPillItem[];
	/** Componente link da usare (default: link nativo `<a>`); passare il `Link` del router quando serve navigazione client-side. */
	linkComponent?: LinkLike;
}

/** Tab di navigazione orizzontali in stile pillola. */
const NavPills = ({
	items,
	linkComponent: Link = NativeLink,
	className,
	...props
}: NavPillsProps) => (
	<nav className={cn('mb-4 flex flex-wrap items-center gap-2', className)} {...props}>
		{items.map((item) => (
			<Link
				key={item.href}
				href={item.href}
				className={cn('tap-target dash-tab', item.active && 'dash-tab-active')}
			>
				{item.label}
			</Link>
		))}
	</nav>
);
NavPills.displayName = 'NavPills';

export { NavPills };
